import { supabase } from "./supabaseClient";
import {
  detectBrowser,
  detectPlatform,
  getDisplayMode,
  getInstallInstanceId,
  getInstallSessionId,
} from "./appInstallService";

const createUuid = () => {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const appInstallEventKey = {
  promptAvailable: (installId) => `install_prompt_available:${installId}`,
  ctaShown: (installId, dateKey) => `install_cta_shown:${installId}:${dateKey}`,
  ctaClicked: (installId) => `install_cta_clicked:${installId}:${createUuid()}`,
  promptAccepted: (installId) => `install_prompt_accepted:${installId}`,
  promptDismissed: (installId, dateKey) => `install_prompt_dismissed:${installId}:${dateKey}`,
  appInstalled: (installId) => `appinstalled:${installId}`,
  standaloneLaunch: (installId, sessionId) => `standalone_launch:${installId}:${sessionId}`,
};

export const todayKey = () => new Date().toISOString().slice(0, 10);

export const recordAppInstallEvent = async (
  eventType,
  { eventKey, promptPlatform = null } = {},
) => {
  const installId = getInstallInstanceId();
  if (!installId || !eventKey) return null;

  const { data, error } = await supabase.rpc(
    "marketing_record_app_event_v1",
    {
      p_payload: {
        event_type: eventType,
        event_key: eventKey,
        install_id: installId,
        platform: detectPlatform(),
        browser: detectBrowser(),
        display_mode: getDisplayMode(),
        route_path:
          typeof window !== "undefined"
            ? `${window.location.pathname || "/"}${window.location.search || ""}`
            : "/",
        prompt_platform: promptPlatform,
      },
    },
  );

  if (error) throw error;
  return data;
};

export const currentInstallIdentity = () => ({
  installId: getInstallInstanceId(),
  sessionId: getInstallSessionId(),
});
